import { Fragment, ReactElement, useMemo } from 'react';
import { MarriageNotificationsNonResidentCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { MarriageNotificationsNonResidentSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { MarriageNotificationsNonResidentMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { MarriageNotificationsNonResidentCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { MarriageNotificationsNonResidentCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import ResearchMarriageNonResidentNotificationsShared from '../../research-notifications/research-marriage-non-resident';

interface ResearchMarriageNonResidentNotificationsCivilStatusSharedProps {
  scope?: string;
}

const ResearchMarriageNonResidentNotificationsCivilStatusShared = ({
  scope,
}: ResearchMarriageNonResidentNotificationsCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idCat = params.idCat || undefined;
  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const editSipoUrl: string = useMemo(() => {
    return `${goBackUrl}/matrimonio/non-residenti/persona-sipo`;
  }, [goBackUrl]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/matrimonio/non-residenti/registrazione/:idIntestatario/:idSchedaSoggettoANPR`;
  }, [goBackUrl]);

  const items = useMemo(() => {
    if (idCat) {
      return MarriageNotificationsNonResidentCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return MarriageNotificationsNonResidentCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return MarriageNotificationsNonResidentSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return MarriageNotificationsNonResidentMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return MarriageNotificationsNonResidentCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, idCat]);

  return (
    <Fragment>
      <ResearchMarriageNonResidentNotificationsShared
        redirectUrl={redirectUrl}
        goBackUrl={goBackUrl}
        items={items}
        editSipoUrl={editSipoUrl}
      />
    </Fragment>
  );
};

ResearchMarriageNonResidentNotificationsCivilStatusShared.displayName =
  'Research Marriage Non Resident Notifications CivilStatusShared component';

export default ResearchMarriageNonResidentNotificationsCivilStatusShared;
